import React from 'react';
import { Create, SimpleForm, TextInput } from 'react-admin';

const EtiquetasCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
        <TextInput source="descripcion" />
    </SimpleForm>
  </Create>
);

export default EtiquetasCreate;
